// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCgez9RbIZIItqTccgBJjsbw0foJKz0fT8",
    authDomain: "mygli-75b68.firebaseapp.com",
    databaseURL: "https://mygli-75b68.firebaseio.com",
    projectId: "mygli-75b68",
    storageBucket: "mygli-75b68.appspot.com",
    messagingSenderId: "256467916453",
    appId: "1:256467916453:web:f4458e8aa8a1ea06ca9f4c",
    measurementId: "G-13F6FFCR4P"
  },
  // interstitialID: "ca-app-pub-3940256099942544/4411468910",
  // bannerID: "ca-app-pub-3940256099942544/2934735716",
  // rewardID: "ca-app-pub-3940256099942544/1712485313",
  interstitialID: "ca-app-pub-1599268370016348/3625843729",
  bannerID: "ca-app-pub-1599268370016348/4668518573",
  rewardID: "ca-app-pub-1599268370016348/6374328394",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
